import type { FC, PropsWithChildren } from 'react'

import React from 'react'

import styled from '@emotion/styled'

import Divider from '@segment/matcha/components/Divider'

import Typography from '@segment/matcha/components/Typography'

import * as CopyText from '@segment/matcha/recipes/CopyText'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

export const paragraphs = [
  `Twilio Segment’s third annual Growth Report is a yearly exploration of the tools, technology, and techniques businesses are using to grow in 2023. This year, It should surprise no one that one trend came through in our survey loud and clear – the rise of AI.`,
  `We saw an unprecedented level of AI adoption, and real business impact being achieved. Additionally, as AI becomes more deeply rooted within organizations, more advanced strategies are being leveraged to maximize its potential.`,
  `In this year’s Growth Report, we surveyed 2,450 marketing, CX, and data leaders from across industries to explore what it means to grow sustainably in 2023, and how companies are using AI to do just that.`,
]

const copy = {
  overline: `Introduction`,
  heading: `More than meets the AI`,
}

const Introduction: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper id="introduction">
      <StyledSectionBase variant="noCopy">
        <Section.Contents>
          <StyledCopyTextOverline tag="h2" variant="overline">
            {copy.overline}
          </StyledCopyTextOverline>
          <StyledDivider />
          <StyledCopyTextHeading>{copy.heading}</StyledCopyTextHeading>
          {paragraphs.map((item, index) => (
            <Typography variant="pSmall" key={index}>
              {item}
            </Typography>
          ))}
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding: 0;
    padding-bottom: 56px;
  }
`

const StyledCopyTextOverline = styled(CopyText.Overline)`
  text-transform: none;
  letter-spacing: 0;
`

const StyledDivider = styled(Divider)`
  margin: 25px 0 0;
`

const StyledCopyTextHeading = styled(CopyText.Heading)`
  padding-top: 16px;
`

export default Introduction
